import React from "react";
import styled from "styled-components";
import { Checkbox } from "@material-ui/core";

import {
    Cancel as CancelIcon,
    PlayCircleFilled as PlayCircleFilledIcon
} from "@material-ui/icons";

import { AnimationSettingsMenu } from "./AnimationSettingsMenu";

const AnimationHeaderContainer = styled.div.attrs(({ hilited, dimmed, heightMultiplier }) => ({
    style: {
        backgroundColor: hilited ? "#f1f1f1" : "#ececec",
        height: `${heightMultiplier * 30}px`,
        color: dimmed ? "#999" : "#222"
    }
}))`
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #424242;
        border-top: 1px solid #999;
        border-right: 1px solid #999;
`;

const AnimationHeaderLabel = styled.span`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 5px;
`;

const TextAndButtonContainer = styled.div`
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
`;

export function AnimationHeader({ disabled, hilited, animations, onMouseEnter, onMouseLeave, onMouseDown, setAnimationsValues }) {
    const animationIds = animations.map(({ id }) => id);
    const animationsEnabled = animations.some(animation => !animation.disabled);

    const elementNames = new Set(animations.map(({ elementName }) => elementName));
    const elementName = [...elementNames].join(", ");

    return (
        <AnimationHeaderContainer
            hilited={hilited}
            heightMultiplier={animations.length}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            dimmed={!animationsEnabled}
        >
            <Checkbox
                style={{ backgroundColor: "transparent" }}
                disableRipple={true}
                icon={<CancelIcon style={{ color: animationsEnabled ? "#222" : "#999" }} />}
                checkedIcon={<PlayCircleFilledIcon style={{ color: animationsEnabled ? "#222" : "#999" }} />}
                color="default"
                checked={animationsEnabled}
                disabled={disabled}
                onMouseDown={onMouseDown}
                onChange={event => setAnimationsValues(event, animationIds, { disabled: !event.target.checked })}
            />
            <TextAndButtonContainer>
                <AnimationHeaderLabel>{elementName}</AnimationHeaderLabel>
                <AnimationSettingsMenu animations={animations} setAnimationsValues={setAnimationsValues} />
            </TextAndButtonContainer>
        </AnimationHeaderContainer>
    );
}
